import React from 'react';

const ConnectCounsellor = () => {
    return (
        <svg width='36' height='37' viewBox='0 0 36 37' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M19.1828 5.07799C19.0118 5.14718 18.8852 5.29624 18.8453 5.47624C18.8048 5.6568 18.8554 5.84524 18.9809 5.9808C20.1413 7.23799 20.8506 8.91762 20.8506 10.7621C20.8506 13.2579 19.5512 15.4522 17.5932 16.706C17.4374 16.8056 17.3406 16.9749 17.3339 17.1594C17.3271 17.3433 17.4115 17.5194 17.5594 17.6302C18.7716 18.5369 20.2757 19.0747 21.9047 19.0747C22.5544 19.0747 23.1839 18.9886 23.7835 18.8283L26.3749 19.9336C26.9729 20.1884 27.6642 20.0675 28.1401 19.6248C28.6154 19.1816 28.7847 18.5004 28.5726 17.8861L27.8937 15.9185C28.6964 14.7507 29.1666 13.3361 29.1666 11.8122C29.1666 7.80387 25.9126 4.5498 21.9047 4.5498C20.9423 4.5498 20.0237 4.73768 19.1828 5.07799Z'
                fill='#6287D0'
            />
            <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M13.4331 32.3725C13.4331 31.2075 12.9707 30.0904 12.1466 29.2669C11.3231 28.4428 10.206 27.9805 9.04106 27.9805C8.0775 27.9805 7.04306 27.9805 6.0795 27.9805C4.91456 27.9805 3.79744 28.4428 2.97394 29.2669C2.15044 30.0904 1.6875 31.2075 1.6875 32.3725C1.6875 33.5008 2.60212 34.4155 3.7305 34.4155C5.75494 34.4155 9.36563 34.4155 11.3901 34.4155C12.5184 34.4155 13.4331 33.5008 13.4331 32.3725Z'
                fill='#E7E9EB'
            />
            <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M34.3124 32.1655V32.125C34.3124 29.9504 32.5496 28.1875 30.3749 28.1875C29.264 28.1875 28.0293 28.1875 26.9189 28.1875C24.7443 28.1875 22.9814 29.9504 22.9814 32.125C22.9814 32.1385 22.9814 32.152 22.9814 32.1655C22.9814 32.7623 23.2183 33.3349 23.6401 33.7568C24.062 34.1787 24.6346 34.4155 25.2314 34.4155C27.1226 34.4155 30.1713 34.4155 32.0624 34.4155C32.6593 34.4155 33.2313 34.1787 33.6532 33.7568C34.0756 33.3349 34.3124 32.7623 34.3124 32.1655Z'
                fill='#E7E9EB'
            />
            <path
                d='M7.56076 27.3979C9.33774 27.3979 10.7783 25.9574 10.7783 24.1804C10.7783 22.4034 9.33774 20.9629 7.56076 20.9629C5.78379 20.9629 4.34326 22.4034 4.34326 24.1804C4.34326 25.9574 5.78379 27.3979 7.56076 27.3979Z'
                fill='#FFE2D9'
            />
            <path
                d='M28.8295 26.8518C30.4558 26.8518 31.7741 25.5334 31.7741 23.9071C31.7741 22.2808 30.4558 20.9624 28.8295 20.9624C27.2031 20.9624 25.8848 22.2808 25.8848 23.9071C25.8848 25.5334 27.2031 26.8518 28.8295 26.8518Z'
                fill='#FFE2D9'
            />
            <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M7.07733 15.4173L6.29208 17.6898C6.06146 18.3592 6.24652 19.1017 6.76402 19.5843C7.28208 20.067 8.03639 20.1992 8.68721 19.9213L11.6578 18.6545C12.3401 18.8396 13.0578 18.9386 13.7986 18.9386C18.3116 18.9386 21.9757 15.2745 21.9757 10.7615C21.9757 6.2486 18.3116 2.58447 13.7986 2.58447C9.28571 2.58447 5.62158 6.2486 5.62158 10.7615C5.62158 12.4907 6.15933 14.0955 7.07733 15.4173Z'
                fill='#264C97'
            />
            <circle cx='10' cy='11' r='1' fill='white' />
            <circle cx='14' cy='11' r='1' fill='white' />
            <circle cx='18' cy='11' r='1' fill='white' />
        </svg>
    );
};

export default ConnectCounsellor;
